export default "__VITE_ASSET__BLGNJ5Zg__"